import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const DeleteIcon = (props: SvgIconProps) => (
  <DeleteOutlineOutlinedIcon {...props} fontSize="small" />
);

export default DeleteIcon;
